import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import AdminNavbar from "./AdminNavbar";
import Navbar from "./Navbar";
import Icon from "@material-tailwind/react/Icon";
import Swal from "sweetalert2";
import { invalidateSession } from "helpers/Session";

export default function Sidebar({ checkUser }) {
  const [showSidebar, setShowSidebar] = useState("-left-64");
  const location = useLocation().pathname.split("/")[1];
  
  const logout = () => {
    Swal.fire({
      title: "Yakin Mau Keluar?",
      text: "Tekan OK jika yakin",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#1F6F78',
      cancelButtonColor: '#EF4444',
      customClass: {
        popup: 'rounded-2xl shadow-glass border border-white/20',
        confirmButton: 'rounded-lg px-6 py-2 transition-all duration-300',
        cancelButton: 'rounded-lg px-6 py-2 transition-all duration-300',
      }
    }).then((value) => {
      if (value.isConfirmed) {
        invalidateSession();
        window.location.reload();
      }
    });
  };

  return (
    <>
      {location.toLowerCase() !== "detailRapor" ? (
        <>
          {checkUser ? (
            <>
              <AdminNavbar
                showSidebar={showSidebar}
                setShowSidebar={setShowSidebar}
              />
              <div
                className={`h-screen fixed top-0 md:left-0 ${showSidebar} overflow-y-auto flex-row flex-nowrap overflow-hidden shadow-glass bg-surface w-64 z-20 py-6 px-6 transition-all duration-300 border-r border-white/20`}
              >
                <div className="flex-col items-stretch min-h-full flex-nowrap px-0 relative">
                  <div className="text-center flex items-center justify-center mb-8 mt-2">
                    <div className="w-12 h-12">
                      <img
                        src={"/assets/logo.png"}
                        alt={"Logo SGE"}
                        className="object-contain drop-shadow-sm"
                      />
                    </div>
                    <h1 className="text-xl leading-normal font-bold text-text-heading self-center ml-3 tracking-tight">
                      Motion Admin
                    </h1>
                  </div>
                  <div className="flex flex-col flex-1 h-full">
                    <ul className="flex-col min-w-full flex list-none space-y-2 mt-4">
                      <li>
                        <NavLink
                          to="/dashboard"
                          exact
                          className="flex items-center gap-4 text-sm font-medium px-4 py-3 rounded-xl text-text-muted hover:bg-primary/10 hover:text-primary transition-all duration-300"
                          activeClassName="bg-primary text-white shadow-soft hover:bg-primary hover:text-white"
                        >
                          <Icon name="dashboard" size="xl" />
                          Dashboard
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/user"
                          className="flex items-center gap-4 text-sm font-medium px-4 py-3 rounded-xl text-text-muted hover:bg-primary/10 hover:text-primary transition-all duration-300"
                          activeClassName="bg-primary text-white shadow-soft hover:bg-primary hover:text-white"
                        >
                          <Icon name="person" size="xl" />
                          Anggota SGE
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/kegiatan"
                          className="flex items-center gap-4 text-sm font-medium px-4 py-3 rounded-xl text-text-muted hover:bg-primary/10 hover:text-primary transition-all duration-300"
                          activeClassName="bg-primary text-white shadow-soft hover:bg-primary hover:text-white"
                        >
                          <Icon name="groups" size="xl" />
                          Kegiatan SGE
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/rapor"
                          className="flex items-center gap-4 text-sm font-medium px-4 py-3 rounded-xl text-text-muted hover:bg-primary/10 hover:text-primary transition-all duration-300"
                          activeClassName="bg-primary text-white shadow-soft hover:bg-primary hover:text-white"
                        >
                          <Icon name="feed" size="xl" />
                          Rapor
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/aspek"
                          className="flex items-center gap-4 text-sm font-medium px-4 py-3 rounded-xl text-text-muted hover:bg-primary/10 hover:text-primary transition-all duration-300"
                          activeClassName="bg-primary text-white shadow-soft hover:bg-primary hover:text-white"
                        >
                          <Icon name="format_list_numbered" size="xl" />
                          Aspek
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/bestStaff"
                          className="flex items-center gap-4 text-sm font-medium px-4 py-3 rounded-xl text-text-muted hover:bg-primary/10 hover:text-primary transition-all duration-300"
                          activeClassName="bg-primary text-white shadow-soft hover:bg-primary hover:text-white"
                        >
                          <Icon name="star" size="xl" />
                          Best Staff
                        </NavLink>
                      </li>
                    </ul>
                    
                    <div className="mt-20">
                      <button
                        className="flex w-full items-center justify-center gap-3 text-sm text-danger hover:text-white font-medium px-4 py-3 rounded-xl border border-danger/30 hover:bg-danger hover:border-danger hover:shadow-soft transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-danger/50"
                        onClick={(e) => {
                          logout();
                        }}
                      >
                        <Icon name="logout" size="xl" />
                        Logout
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <Navbar />
            </>
          )}
        </>
      ) : (
        <></>
      )}
    </>
  );
}
